import { Box, Skeleton } from '@mui/material'
import React from 'react'

export const HouseCarouselSkeletonLoader = () => {
  return (
    <Box className='placeholder'>
      <Skeleton variant='rectangular' width='100%' height={335} />
    </Box>
  )
}
